<chart [type]="'radar'" [data]="radarData" [options]="radarOptions"></chart>